import React, {Suspense, useContext} from 'react';
import { MapContainer, TileLayer, useMap, Marker, Popup,  } from 'react-leaflet';
import MultiLingualContent from "../config/multilingualContent";
import { LanguageContext } from "../config/multilingualContext";
import PageWrapper from "../components/PageWrapper";
import Footer from "../components/Footer";
//import ErrorBoundary from '../components/ErrorBoundary';

import {show} from '../constants/countries.override'
import { MultiCascadeTree } from 'rsuite';

const SigComponent = show ? React.lazy(() => import('../components/SigMapEcharts')) : React.lazy(() => import('../components/SigMap'));


const Sig = () => {
    return (

        <>
            <PageWrapper>
                <div className="text-center homepage">
                    <Suspense fallback={<div>Chargement de la carte...</div>}>
                    <SigComponent />
                    </Suspense>*
                    <Footer />
                </div>
            </PageWrapper>

        </>

    );
};

export default Sig;